import { createCache, PetShop } from 'pet-shop';
import { createMiniStorage } from 'pet-shop/dist/mini-store.js';

const namespace = `xinxiangsui-${import.meta.env.CONFIG_NAME}`;

export type UserInfo = {
  id?: string;
  userId?: string;
  avatarUrl?: string;
  name?: string;
  remark?: string;
  phone?: string;
};

export type Store = {
  'family-selected'?: string;
  'need-phone'?: boolean;
  'phone-bind-from'?: string;
  code?: string;
  deviceId?: string;
  info?: UserInfo;
  loop?: string;
  tenant?: string;
  token?: string;
};

export const sessionStore = PetShop<Store>({
  namespace,
  storage: import.meta.env.IS_MINIPROGRAM
    ? createMiniStorage(wx)
    : sessionStorage,
  json: true,
});

export const Auth = createCache(sessionStore, ['token', 'tenant', 'info']);

export const Temp = createCache(sessionStore, ['deviceId', 'loop']);

if (
  import.meta.env.WATCHING &&
  !/wechatdevtools/i.test(window.navigator.userAgent) &&
  !window.matchMedia('print').matches
) {
  // Auth.token = '68a6ff38-a89a-11f0-b542-57ba9c122cf2';
  Auth.token = '99669e56-dfb1-11f0-b80b-3575677eef0d';
}
